/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FAnonymousType204 } from './FAnonymousType204';
import {
    FAnonymousType204FromJSON,
    FAnonymousType204FromJSONTyped,
    FAnonymousType204ToJSON,
    FAnonymousType204ToJSONTyped,
} from './FAnonymousType204';
import type { FAnonymousType112 } from './FAnonymousType112';
import {
    FAnonymousType112FromJSON,
    FAnonymousType112FromJSONTyped,
    FAnonymousType112ToJSON,
    FAnonymousType112ToJSONTyped,
} from './FAnonymousType112';

/**
 * 
 * @export
 * @interface FAnonymousType216
 */
export interface FAnonymousType216 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType216
     */
    id?: number;
    /**
     * 
     * @type {FAnonymousType112}
     * @memberof FAnonymousType216
     */
    definition?: FAnonymousType112;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType216
     */
    status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FAnonymousType216
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType216
     */
    data?: string | null;
    /**
     * 
     * @type {Array<FAnonymousType204>}
     * @memberof FAnonymousType216
     */
    measurements?: Array<FAnonymousType204> | null;
}

/**
 * Check if a given object implements the FAnonymousType216 interface.
 */
export function instanceOfFAnonymousType216(value: object): value is FAnonymousType216 {
    return true;
}

export function FAnonymousType216FromJSON(json: any): FAnonymousType216 {
    return FAnonymousType216FromJSONTyped(json, false);
}

export function FAnonymousType216FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType216 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'definition': json['definition'] == null ? undefined : FAnonymousType112FromJSON(json['definition']),
        'status': json['status'] == null ? undefined : json['status'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'data': json['data'] == null ? undefined : json['data'],
        'measurements': json['measurements'] == null ? undefined : ((json['measurements'] as Array<any>).map(FAnonymousType204FromJSON)),
    };
}

export function FAnonymousType216ToJSON(json: any): FAnonymousType216 {
    return FAnonymousType216ToJSONTyped(json, false);
}

export function FAnonymousType216ToJSONTyped(value?: FAnonymousType216 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'definition': FAnonymousType112ToJSON(value['definition']),
        'status': value['status'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'data': value['data'],
        'measurements': value['measurements'] == null ? undefined : ((value['measurements'] as Array<any>).map(FAnonymousType204ToJSON)),
    };
}

